import { GetServerSideProps } from 'next';
import { getApolloClient } from '@/lib/ApolloClient';
import getDeviceCharacteristics from '@/utils/getDeviceCharacteristics';
import reqHeaderToEntriesObj from '@/utils/reqHeaderToEntriesObj';
import { seoSegmentationsByCityOrState as seoSegmentationsByCityOrStateQuery } from '@/API/seoSegmentationsByCityOrState';
import { getSegmentationBreadcrumbs } from '@/API/getSegmentationBreadcrumbs';

export const getServerSideProps: GetServerSideProps = async ({ query, req, res }) => {
  const startPageGSSP = performance.now();
  const apolloOptions = {
    logError: req.log.error.bind(req.log),
    logInfo: req.log.info.bind(req.log),
  };
  const startApolloClient = performance.now();
  const apolloClient = getApolloClient(apolloOptions);
  const stopApolloClient = performance.now();
  const isLocal = process.env.NODE_ENV === 'development';
  const userAgent = req.headers['user-agent'] || '';
  const deviceCharHeader = req.headers['x-akamai-device-characteristics']?.toString() || '';
  const deviceChar = isLocal
    ? getDeviceCharacteristics(userAgent, deviceCharHeader)
    : reqHeaderToEntriesObj(deviceCharHeader, ';');

  const { segment } = query;
  const seoSegmentId = `/all-services/${segment}`;

  const startGetPageData = performance.now();
  const [seoSegmentationsByCityOrStateResponse, getSegmentationBreadcrumbsResponse] =
    await Promise.all([
      seoSegmentationsByCityOrStateQuery(apolloClient, req.log, {
        seoSegmentId,
      }),
      getSegmentationBreadcrumbs(apolloClient, {
        seoSegmentId,
      }),
    ]);
  const stopGetPageData = performance.now();
  const { seoSegmentationsByCityOrState, error } = seoSegmentationsByCityOrStateResponse;

  if (seoSegmentationsByCityOrState === null && error) {
    req.log.error({
      event: 'cityServicesDirectoryLoadError',
      seoSegmentId,
      userAgent,
      deviceChar,
      query,
      res,
      error,
    });
    return {
      notFound: true,
    };
  }

  const pageData = {
    ...seoSegmentationsByCityOrState,
    ...getSegmentationBreadcrumbsResponse.queryResponse?.data.getSEOSegmentationBreadcrumbs,
  };

  const pageProps = {
    props: {
      pageData,
      seoSegmentId,
      deviceChar,
    },
  };

  req.log.info({
    event: 'cityServicesDirectoryLoadSuccess',
    seoSegmentId,
    userAgent,
    deviceChar,
    query,
    res,
  });
  const stopPageGSSP = performance.now();
  req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
  req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
  req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;

  return pageProps;
};
